var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tl",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h496v496H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb000f",
    d: "M0 0h999v496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8c00c",
    d: "M0 0c3.1 0 496 248.7 496 248.7L0 496.1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2 0 330 248.7 330 248.7L0 496.1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m181.9 288.9-59-13L93 327l-5-57.8-58.8-13 53.1-24-3.2-57.5 39 42 53.6-24.4-28 52.2 38 44.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl);
export default __webpack_public_path__ + "static/media/tl.5be85f97d14b2c88653627b00bec76cc.svg";
export { ForwardRef as ReactComponent };